"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIStepperInput = _interopRequireDefault(require("UIComponents/input/UIStepperInput"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useDebouncedOnChange3 = require("../hooks/useDebouncedOnChange");

var StyledUITextInput = (0, _styledComponents.default)(_UITextInput.default).withConfig({
  displayName: "MarginInput__StyledUITextInput",
  componentId: "z9my3i-0"
})(["min-width:0;"]);
var propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  onChange: _propTypes.default.func.isRequired,
  useContextualToolbar: _propTypes.default.bool
};

function MarginInput(props) {
  var value = props.value,
      onChange = props.onChange,
      useContextualToolbar = props.useContextualToolbar;

  var _useDebouncedOnChange = (0, _useDebouncedOnChange3.useDebouncedOnChange)(onChange),
      _useDebouncedOnChange2 = (0, _slicedToArray2.default)(_useDebouncedOnChange, 2),
      handleInputChange = _useDebouncedOnChange2[0],
      handleStepChange = _useDebouncedOnChange2[1];

  if (typeof value !== 'number') {
    return _react.default.createElement(StyledUITextInput, {
      disabled: true,
      value: value,
      onChange: handleInputChange,
      size: useContextualToolbar ? 7 : undefined
    });
  }

  return _react.default.createElement(_UIStepperInput.default, {
    min: 0,
    max: 999,
    stepSize: 1,
    size: useContextualToolbar ? 3 : 6,
    value: value,
    onChange: handleInputChange,
    onStep: handleStepChange
  });
}

MarginInput.propTypes = propTypes;
MarginInput.displayName = 'MarginInput';
var _default = MarginInput;
exports.default = _default;
module.exports = exports.default;